import * as Yup from "yup";

const mandatoryFieldsEnv = process.env.REACT_APP_MANDATORY_FIELDS || "";
export const MANDATORY_FIELDS = mandatoryFieldsEnv.split(",").map(f => f.trim().toUpperCase());

export const isFieldMandatory = (field: string): boolean => {
  const result = MANDATORY_FIELDS.includes(field.toUpperCase());
  return result;
};

export const isFieldMissingIfMandatory = (field: string, value: any): boolean => {
  const missing = isFieldMandatory(field) && (!value || value.trim?.() === "");
  return missing;
};

export const requiredIfMandatory = (field: string, schema: Yup.StringSchema | Yup.DateSchema) => {
  return isFieldMandatory(field) ? schema.required(`${field.replace(/_/g, " ")} is required`) : schema.nullable();
};
